/**
 * Застосовує початкові значення фільтра до вже створеного crud-контексту
 * як ЗВИЧАЙНИЙ користувацький фільтр (а не дефолт ресурсу) і ОДНОРАЗОВО
 * прибирає query-параметри фільтра з URL.
 *
 * Чому одноразово + чистимо URL: статус приходить з query (напр.
 * /requests?status=new при переході з головної). Якщо лишити query в URL,
 * то при будь-якому ре-рендері/перестворенні контексту фільтр застосовується
 * знову — і кнопка «Очистити» у Filter.jsx начебто спрацьовує, але фільтр
 * одразу повертається з URL. Тому після першого застосування ми:
 *   1) пишемо значення у values форми (щоб поле відобразилось у фільтрі)
 *      та у listContext.filter (щоб дані одразу відфільтрувались);
 *   2) НЕ кладемо нічого в initialValues — тож «Очистити»
 *      (reset → порожні initialValues + setFilter({})) реально очищає;
 *   3) прибираємо query з URL через history.replaceState (без перезавантаження
 *      і без запису в history), щоб фільтр більше не «воскресав».
 */
export function applyInitialFilter(
    crudContext: any,
    values: Record<string, any> | null | undefined,
): void {
    if (!crudContext || !values || Object.keys(values).length === 0) return

    const formContext = crudContext.filterFormContext
    const listContext = crudContext.listContext

    Object.entries(values).forEach(([key, value]) => {
        // values форми — щоб поле відобразилось у відкритому фільтрі
        formContext?.setValue?.(key, value)
        // filter списку — щоб дані одразу відфільтрувались при завантаженні
        listContext?.setFilterOne?.(key, value)
    })

    // Прибираємо застосовані ключі з query URL, лишаючи решту параметрів.
    stripQueryKeys(Object.keys(values))
}

/** Видаляє вказані ключі з query поточного URL без перезавантаження сторінки. */
function stripQueryKeys(keys: string[]): void {
    if (typeof window === 'undefined' || !window.history?.replaceState) return

    const url = new URL(window.location.href)
    let changed = false
    keys.forEach((key) => {
        if (url.searchParams.has(key)) {
            url.searchParams.delete(key)
            changed = true
        }
    })
    if (!changed) return

    const newSearch = url.searchParams.toString()
    window.history.replaceState(window.history.state, '', url.pathname + (newSearch ? `?${newSearch}` : '') + url.hash)
}
